// ABOUTME: Investigation detail page with chat interface.
// ABOUTME: Renders the full investigation chat with WebSocket streaming.

import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useApp } from '@/context/AppContext';
import { InvestigationChat } from '@/components/investigation';

export function InvestigationDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { startNewSession, loadSession, currentSessionId } = useApp();
  const [isCreating, setIsCreating] = useState(false);

  // Handle session initialization
  useEffect(() => {
    if (id === 'new') {
      // Start a new session if not already in one
      if (!currentSessionId && !isCreating) {
        setIsCreating(true);
        startNewSession().then((newId) => {
          // Navigate to the real investigation ID
          navigate(`/investigations/${newId}`, { replace: true });
          setIsCreating(false);
        }).catch((err) => {
          console.error('Failed to create investigation:', err);
          setIsCreating(false);
        });
      }
    } else if (id && id !== currentSessionId) {
      // Load existing session
      loadSession(id);
    }
  }, [id, currentSessionId, startNewSession, loadSession, navigate, isCreating]);

  const handleClose = () => {
    navigate('/investigations');
  };

  // Show loading state while creating new investigation
  if (id === 'new' && isCreating) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-surface-500">Creating investigation...</div>
      </div>
    );
  }

  // Use the session ID from the URL or the current session
  const investigationId = id === 'new' ? currentSessionId || '' : id || '';

  // Don't render chat until we have a valid investigation ID
  if (!investigationId) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-surface-500">Loading...</div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <InvestigationChat
        investigationId={investigationId}
        onClose={handleClose}
      />
    </div>
  );
}
